// extracted by mini-css-extract-plugin
module.exports = {"crossSellTitle":"crossSellTitle-module__crossSellTitle___1aGZ8"};